import { useEffect, useState } from 'react';
import { accountingGateway } from './index';
import type { AccountingExportCapabilities } from './exportTypes';

/**
 * What the signed-in person can do with accounting exports, as the server says it (booleans only, `GET /api/accounting-export-capabilities`). It decides
 * what the screen OFFERS (for example whether Export CSV, Per Employee or Generate reversal is shown); it never decides what is allowed: the server
 * still enforces every action and a 403 is still handled wherever one can arrive.
 *
 * `caps` is `null` until the answer arrives and when it cannot be read (the service is down, or an older server): the screen then offers everything
 * and relies on the server's refusal.
 */
export function useExportCapabilities(): { caps: AccountingExportCapabilities | null; loaded: boolean } {
  const [state, setState] = useState<{ caps: AccountingExportCapabilities | null; loaded: boolean }>({ caps: null, loaded: false });
  useEffect(() => {
    const controller = new AbortController();
    accountingGateway
      .getExportCapabilities(controller.signal)
      .then((caps) => { if (!controller.signal.aborted) setState({ caps, loaded: true }); })
      .catch(() => { if (!controller.signal.aborted) setState({ caps: null, loaded: true }); });
    return () => controller.abort();
  }, []);
  return state;
}
